import React from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';

const InsufficientPointsCancel = (props) => {
    const required = props?.pointsRequired ?? 0;
    const available = props?.pointsAvailable ?? 0;

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Not enough points'}
            titleIcon={'error'}
            positiveTitle={'Yes, cancel without deducting'}
            positivePress={() => props.submit()}
            positiveButtonStyle={{ backgroundColor: '#44d62c', color: 'white', border: '1px solid #44d62c' }}
            negativePress={() => props.close()}
            negativeTitle={'No'}
            width={'35%'}
        >
            <div style={{ fontSize: 14, color: '#282828', lineHeight: 1.5 }}>
                The customer does not have enough points to deduct.
                <div className="mt-2">
                    Required: <strong>{required}</strong>
                    <br />
                    Available: <strong>{available}</strong>
                </div>
                <div className="mt-3">
                    Proceed to cancel the order <strong>without</strong> deducting points?
                </div>
            </div>
        </AppDialog>
    )
}

export default InsufficientPointsCancel;
